import { getAppConfig, getRestaurantLocale } from '../../constants/appConfig';
import store from '../../store';

/**
 * Use the appConfig, but magically use the restaurant's locale
 */
export const useAppConfig = () => {
  return getAppConfig(getRestaurantLocale(store?.getState()?.restaurantActive?.restaurant));
};
